import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import { SET_LOADER } from '../redux/Loader';
import { POST } from '../consts/Methods';
import { SIGN_OUT, SIGN_OUT_FAIL } from '../redux/UserData';

function* signOutFlow() {
  try {
    const endpoint = '/dealers/auth/sign_out';
    yield call(apiCall, { method: POST, endpoint, });
    window.location = '/dashboard/auth/sign-in';
  } catch (error) {
    yield put(SIGN_OUT_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* SignOutSagaSaga() {
  yield takeLatest(SIGN_OUT, signOutFlow);
}
